import { render, staticRenderFns } from "./OpenSeadragon.vue?vue&type=template&id=53e41c05"
import script from "./OpenSeadragon.vue?vue&type=script&lang=js"
export * from "./OpenSeadragon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports